<template>
  <f7-page class="no-swipeback" login-screen @page:reinit id="login">
    <div class="body">
      <b-row style="height: 100%;">
        <div class="panel21 panel-default loginPanel loginHeight">
          <div style="display:inline-block;vertical-align:middle;">
            <p class="col-sm">
              <img class="logoSmallScreen" :src="imgVars"></img>
            </p>
            <div class="panel-heading ajust">
              <h4 class="panel-title" v-if="!activationCode">
                {{ $t('loginPage.sign_in_activated') }}
              </h4>
              <h4 class="panel-title" v-if="activationCode">
                {{ $t('loginPage.sign_in_not_activated') }}
              </h4>
            </div>
            <div @keyup.enter="quickLogin()">
              <b-row>
                <b-col class="form-group">
                  <form-write-group-label-input v-model="credentials.Login"
                    inputType="email"
                    :placeholderValue="loginpage_Identifier"
                    :customHeight="'44'">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="form-group">
                  <div class="form-control passwordControl"
                    style="display:flex;height: 44px;">
                    <input v-model="credentials.Password"
                      :type="passwordFieldType"
                      style="border:none;width: 90%;"
                      :placeholder="loginpage_Password">
                    </input>
                    <i class="icon icon-password"
                      :class="[isPasswordFieldHidden ? 'icon-eye_blind' : 'icon-eye']"
                      @click="toggleVisibility">
                    </i>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="withPassword" class="form-group">
                  <div class="form-control passwordControl"
                    style="display:flex;height: 44px;">
                    <input v-model="credentials.PasswordRepeat"
                      :type="passwordFieldType"
                      style="border:none;width: 90%;"
                      :placeholder="loginpage_PasswordRepeat">
                    </input>
                    <i class="icon icon-password"
                      :class="[isPasswordFieldHidden ? 'icon-eye_blind' : 'icon-eye']"
                      @click="toggleVisibility">
                    </i>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="!withPassword" class="form-group">
                <a href="#" @click="resetPassword" style="margin-left:20px;">Mot de passe oublié ?</a>
              </b-row>
            </div>

            <div class="loginButtons" :style="cssVars">
              <button class="logButton loginButton"
                @click="authUser()">
                {{ $t('loginPage.lgn_on_login_page') }}
              </button>
            </div>
            <div class="login-method-separator">
              {{ $t('common.or_label_maj') }}
            </div>
            <div class="loginButtons">
              <button class="logButton loginGoogleButton"
                @click="handleClickSignIn">
                <!-- <div class="icon-google" style="display: inline-block;"></div> -->
                <span style="vertical-align: middle; font-size: 13px;">
                  {{ $t('loginPage.login_ggl_sso') }}
                </span>
              </button>
            </div>
            <hr style="margin-top: 30px;"/>
            <a class="signupLink" href="/register/">{{ $t('common.rgstr') }}</a>
            <cm-account-activation-popup :credentials="credentials">
            </cm-account-activation-popup>
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import _ from 'underscore'
import moment from 'moment'
import design from '@/design/design.json'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import CMAccountActivation from '@/popups/user/CMAccountActivation.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'login',
  components: {
    'cm-account-activation-popup': CMAccountActivation,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    activationCodePassword: {
      default: 'notWithPassword',
      type: String
    }
  },
  data: () => {
    return {
      activationCode: '',
      credentials: {
        Biometrics: {
          Voice: 'string',
          Video: 'string',
          Fingerprint: 'string'
        },
        ConnectBy: false,
        Login: '',
        Password: '',
        PasswordRepeat: ''
      },
      defaultService: 'Direct Debit',
      defaultUrl: '/home/',
      design: design.login,
      isLargeScreen: true,
      passwordFieldType: 'password',
      withPassword: false
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isLargeScreen = false
    }
    this.$bus.$off('refresh-inbox-list-cache')
    this.activationCode = new URL(location.href).searchParams.get('activationCode')
    this.withPassword = new URL(location.href).searchParams.get('withPassword')
    if (this.withPassword === 'true') {
      this.withPassword = true
    } else {
      this.withPassword = false
    }
    if (!this.activationCode) {
      this.activationCode = ''
    }
    this.loginpage_Identifier = this.$i18n.t('common.enter_email')
    this.loginpage_PasswordRepeat = this.$i18n.t('common.conf_pwd')
    this.loginpage_UnvalidEmail = this.$i18n.t('errors.unvalid_email_adr')
    if (this.withPassword) {
      this.loginpage_Password = this.$i18n.t('common.new_pwd')
    } else {
      this.loginpage_Password = this.$i18n.t('common.enter_pwd')
    }
  },
  mounted () {
    if (!this.isLargeScreen) {
      this.$$('.navbar').addClass('deleteNavBar')
    }
    /* TLV 24/08/2020 Si l'utilisateur a déjà une session ouverte et n'est pas en
    * OTP, on le redirige vers la page d'accueil par défaut */
    if (this.$engine.auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPage(this, {url: this.defaultUrl})
    }
  },
  computed: {
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    cssVars () {
      return {
        '--loginButtonColor': this.design.buttonLoginColor,
        '--loginButtonColorHover': this.design.buttonLoginColorHover
      }
    },
    imgVars () {
      return this.design.fontImage
    }
  },
  methods: {
    connect () {
      /* TLV 18/08/2020
      * On précise ici le nom du service et son URL par défaut associées */
      let defaultServiceId = parseInt(this.$engine.services.getServiceIdByName(this.defaultService)) - 1
      let that = this
      that.$engine.services
      .enroll(1, moment('2020-06-10', 'YYYY-MM-DD'))
      .then(response => {
        if (response.status === 200) {
          this.$bus.emit('login', true)
          this.$bus.emit('service:change', this.defaultService)
          this.$bus.emit('refresh-cache-menu')
          that.$f7.hidePreloader()
          this.$$('.panel-overlay').css('z-index', '')
          this.$$('.deleteNavBar').removeClass('deleteNavBar')
          // let serviceInbox = '/inbox/0'
          // loadPage(that, {url: serviceInbox})
          // that.$f7.popup('#service-switcher-true')
          if (this.$engine.user.getIsFirstLogin() === '1') {
            this.$bus.emit('service:change', this.defaultService)
            // loadPage(that, {url: '/inbox/0'})
            that.$engine.services.payments.update(0, 1, 1,
              {
                statusWaiting: 1
              }
            )
            .then(resp => {
              // if (resp.data.payments.length > 0) {
              //   that.$engine.settings.set({clickedMessage: resp.data.payments[0]})
              //   that.$engine.settings.set({msgFromInbox: true})
              //   that.$engine.user.setIsFirstLogin('0')
              //   loadPage(that, {url: '/directPayments/transaction-details/0/'})
              // } else {
              //   loadPage(that, {url: '/directPayments/inbox/'})
              // }
              /* IRY 04/2020 A la première connexion, on est redirigé vers le dashboard */
              loadPage(that, {url: that.defaultUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          } else {
            switch (this.$engine.user.get().favourite_service) {
              /*
              case '2' :
                this.$bus.emit('service:change', 'Direct Debit')
                loadPage(that, {url: '/directDebit/inbox/'})
                break
                */
              default :
                this.$engine.user.changeService(this.$engine.services.get()[defaultServiceId])
                let that = this
                const changeService = new Promise(function (resolve, reject) {
                  loadPage(that, {url: that.defaultUrl})
                  resolve()
                })
                changeService.then(function () {
                  that.$bus.emit('service:change', that.defaultService)
                })
                break
              // TLV 20/01/2020 : Pour la démo, la page d'accueil est la inbox des DP
              /* case '6' :
                this.$bus.emit('service:change', 'Direct Payments')
                loadPage(that, {url: '/directPayments/inbox/'})
                break
              default :
                this.$bus.emit('service:change', 'Payments')
                loadPage(that, {url: '/dashboard/'}) */
            }
          }
        }
      }).catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    authUser () {
      if (this.withPassword) {
        if (this.credentials.Login === '') {
          this.$f7.alert('Login missing', 'Error')
          return
        } else if (this.credentials.Password === '') {
          this.$f7.alert('Password missing', 'Error')
          return
        } else if (this.credentials.PasswordRepeat === '') {
          this.$f7.alert('Password confirm missing', 'Error')
          return
        } else if (this.credentials.Password !== this.credentials.PasswordRepeat) {
          this.$f7.alert('Passwords do not match', 'Error')
          return
        }
      }
      let that = this
      this.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
      const creds = _.clone(this.credentials)
      creds.ConnectBy = 'lpc'
      if (this.withPassword) {
        creds.WithPassword = '1'
      }
      this.$engine.auth.login(creds)
      .then(resp => {
        this.$engine.user.connectBy = 'login-password-capi'
        that.connect()
      })
      .catch(err => {
        that.$f7.hidePreloader()
        if (this.activationCode.length > 0) {
          this.activateAccount(this.activationCode)
        } else {
          errorMessageAlert(err, this)
        }
      })
    },
    quickLogin () {
      if (this.credentials.Login.length !== 0 && this.credentials.Password.length !== 0) {
        this.authUser()
      }
    },
    activateAccount (code) {
      this.$f7.showPreloader('Activating account')
      let that = this
      if (code !== '') {
        this.$engine.auth.activate(code, this.withPassword, this.credentials.Password)
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              this.authUser()
            }
          }).catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // this.showModalActivationCode()
            // that.Dom7('.accountActivationInput2').val(code)
          })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
        this.showModalActivationCode()
      }
    },
    resetPassword () {
      this.$f7.popup('#cm-user-reset-password-true')
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.auth.getNewActivationCode()
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, this)
        })
    },
    showModalActivationCode () {
      let that = this
      that.$$('.blueConfirmationButtonActivationOK2').on('click')
      that.$f7.modal({
        title: 'Activate Account',
        text: 'Please enter your activation code',
        afterText: '<input class="accountActivationInput2" type="text"><p class="blueConfirmationButtonActivationOK2">OK</p>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          },
          {
            text: 'Send new code',
            onClick: function () {
              that.sendAnotherCode()
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          }
        ]
      })
      that.$$('.blueConfirmationButtonActivationOK2').on('click', function (e) {
        that.$f7.closeModal()
        that.activateAccount(that.Dom7('.accountActivationInput2').val())
      })
    },
    toggleVisibility ($event) {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    handleClickSignIn () {
      let that = this
      // On se conecte via Google
      this.$gAuth.signIn()
      .then(GoogleUser => {
        var gu = GoogleUser.getBasicProfile()
        var FirstName = gu.getGivenName()
        var LastName = gu.getFamilyName()
        var Login = gu.getEmail()
        var Password = gu.getId()
        this.$engine.user.connectBy = 'vue-google-oauth2'
        // est-ce qu'on est inscrit ? pour cela, on essait de se connecter
        that.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
        const creds = _.clone(that.credentials)
        creds.Login = Login
        creds.Password = Password
        creds.ConnectBy = 'vgo'
        this.$engine.auth.login(creds)
        .then(resp => {
          // J'existe
          this.connect()
        }).catch(() => {
          // On fail do something
          that.$f7.hidePreloader()
          this.$engine.auth.getLogin(Login, 'lpc')
          .then(() => {
            // Le compte existe en mode lpc.
            that.$f7.alert('The email sent by Google is already present in the database', 'Log in with your account')
          })
          .catch(err => {
            console.log(err)
            // console.log('/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password)
            loadPage(that, {url: '/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password})
          })
        })
      })
      .catch(err => {
        // On fail do something
        if (err === false) {
          this.connect()
        }
      })
    }
  }
}
</script>
<style>
.list-block .list-button {
  padding: 0;
}
.panel-heading.ajust {
  padding: 9px 10px 20px 0px;
  margin-top: 18px;
}
.panel-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 30px;
}
@media (min-height: 600px) and (max-width: 479px) {
  .loginHeight {
    /* padding-bottom: 100%; */
    height: 100%;
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
  }
}
@media screen and (max-height: 450px) {
  .h-sm-hide {
    display: none;
  }
}

.loginPanel {
  box-shadow: rgba(0,0,0,0.1) 0 0 10px;
  margin: auto !important;
}

.loginPanel:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

@media (min-width: 480px) {
  .loginPanel {
    max-width: 400px;
    padding: 10px 35px 30px 35px;
  }
}

@media (min-width: 1431px) {
  .logoBigScreen {
    width: auto;
    height: auto;
  }
  /* TLV 27/11/2019 : le formulaire de connexion doit être éditable sur grand écran,
    même quand le menu de gauche apparaît */
  .panel-overlay{
    z-index: 1;
  }
}

.logoSmallScreen {
  width: inherit;
  height: auto;
}

@media (min-width: 481px) and (max-width: 991px) {
  .body {
    background: #fff;
  }
}

.icon-password {
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.body {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
}

.passwordControl:focus-within {
  border: 1px solid #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.login-method-separator {
  color: #4d4d4d;
  font-size: 12px;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
}

.signupLink {
  width: 100%;
  text-align: center;
  display: inline-block;
}

.signupLink:hover {
  text-decoration: underline;
  color: #12bcf1;
}

.loginButton:hover {
  background-color: var(--loginButtonColorHover);
}
</style>



// WEBPACK FOOTER //
// CMLogin.vue?5f510469